var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.5 2.115v-.615a1.5 1.5 0 0 0 -3 0v.615a10.968 10.968 0 0 0 -7.214 17.572 3.526 3.526 0 0 0 -1.286 2.813 1.5 1.5 0 0 0 3 0 .641.641 0 0 1 .455-.68 10.917 10.917 0 0 0 13.087 0 .641.641 0 0 1 .458.68 1.5 1.5 0 0 0 3 0 3.526 3.526 0 0 0 -1.286-2.813 10.968 10.968 0 0 0 -7.214-17.572zm-9.5 10.885a8 8 0 1 1 8 8 8.009 8.009 0 0 1 -8-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.5 0a1.5 1.5 0 0 0 0 3 1.361 1.361 0 0 1 1.459 1.5 1.5 1.5 0 0 0 3 0 4.333 4.333 0 0 0 -4.459-4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3.041 4.5a1.361 1.361 0 0 1 1.459-1.5 1.5 1.5 0 0 0 0-3 4.333 4.333 0 0 0 -4.459 4.5 1.5 1.5 0 0 0 3 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.53 12.379v-3.879a1.5 1.5 0 0 0 -1.5-1.5 1.5 1.5 0 0 0 -1.5 1.5v4.293a2 2 0 0 0 .586 1.414l1.793 1.793a1.5 1.5 0 0 0 2.121-2.121z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b5737525e48598bd7f9be9b90023911d.svg";
export { ForwardRef as ReactComponent };